import PersonSilhouetteImg from './PersonSilhouette.png';
import PropTypes from 'prop-types';

const PersonSilhouette = ({ width = 60 }) => {
  return (
    <img
      src={PersonSilhouetteImg}
      alt='Person Silhouette'
      className={`mx-auto`}
      width={`${width}px`}
    />
  );
};

PersonSilhouette.propTypes = {
  width: PropTypes.number,
};

export default PersonSilhouette;
